import { MathJaxContext } from 'better-react-mathjax';
import { useEffect } from 'react';
import Chatbox from './components/Chatbox';
import './App.css';

function App() {
  const config = {
    loader: { load: ["[tex]/html"] },
    tex: {
      packages: { "[+]": ["html"] },
      inlineMath: [
        ['$', '$'],
        ['\\(', '\\)']  // Added support for \( \) notation
      ],
      displayMath: [
        ['$$', '$$'],
        ['\\[', '\\]'],
        ['[', ']']      // Added support for [ ] notation
      ]
    },
    startup: {
      typeset: false
    },
    options: {
      skipHtmlTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code'],
      processHtmlClass: 'math'
    },
    svg: {
      fontCache: 'global'
    },
    chtml: {
      displayAlign: 'left',
      displayIndent: '0'
    }
  };

  // Load and apply settings on app initialization
  useEffect(() => {
    const loadSettings = () => {
      try {
        const savedSettings = localStorage.getItem('chatSettings');
        if (savedSettings) {
          const settings = JSON.parse(savedSettings);
          
          // Apply settings to document with fallbacks
          document.documentElement.setAttribute('data-theme', settings.theme || 'light');
          document.documentElement.setAttribute('data-font-size', settings.fontSize || 'medium');
          document.documentElement.setAttribute('data-compact', settings.compactMode || false);
        } else {
          // Apply default settings if none exist
          document.documentElement.setAttribute('data-theme', 'light');
          document.documentElement.setAttribute('data-font-size', 'medium');
          document.documentElement.setAttribute('data-compact', false);
        }
      } catch (error) {
        // Apply default settings on error
        document.documentElement.setAttribute('data-theme', 'light');
        document.documentElement.setAttribute('data-font-size', 'medium');
        document.documentElement.setAttribute('data-compact', false);
      }
    };

    loadSettings();

    // Listen for settings updates from SettingsPanel
    const handleSettingsUpdate = (event) => {
      try {
        const settings = event.detail;
        if (settings && typeof settings === 'object') {
          document.documentElement.setAttribute('data-theme', settings.theme || 'light');
          document.documentElement.setAttribute('data-font-size', settings.fontSize || 'medium');
          document.documentElement.setAttribute('data-compact', settings.compactMode || false);
        }
      } catch (error) {
        // Error applying settings update
      }
    };

    window.addEventListener('settingsUpdated', handleSettingsUpdate);

    return () => {
      window.removeEventListener('settingsUpdated', handleSettingsUpdate);
    };
  }, []);

  return (
    <div className="App">
      <MathJaxContext config={config}>
        <div className="chat-container">
          <Chatbox />
        </div>
      </MathJaxContext>
    </div>
  );
}

export default App;